/**
 * Message transformation logic
 * Simplified to trust backend format - backend now sends properly formatted messages
 */

import type { ThreadMessage } from '@/types/messages';
import type { ThreadMessage as APIThreadMessage } from '@/interfaces/thread.interface';

/**
 * Transform API messages to ThreadMessage format
 * Simplified since backend now provides properly formatted messages
 */
export function transformApiMessagesToThreadMessages(
  apiMessages: APIThreadMessage[],
  threadId: string
): ThreadMessage[] {
  // Deduplicate messages by ID to prevent duplicate displays
  const uniqueMessages = apiMessages.filter((msg, index, arr) => 
    arr.findIndex(m => m.id === msg.id) === index
  );
  
  return uniqueMessages.map((msg) => {
    const content = msg.content || [];
    const createdAt = msg.createdAt ? new Date(msg.createdAt) : new Date();
    const updatedAt = msg.updatedAt ? new Date(msg.updatedAt) : new Date();
    const metadata = msg.metadata || {};

    return {
      id: msg.id,
      threadId: threadId,
      role: msg.role,
      content: content,
      status: msg.status || 'complete',
      createdAt,
      updatedAt,
      metadata
    } as ThreadMessage;
  });
}